import { PaymentsPaginationType } from "#graphql/supergraphEnums";
import { PaginationArgs } from "#graphql/supergraphTypes";
import { DEFAULT_PAGE_SIZE } from "../../../constants";

/**
 * Prepares the pagination query
 * @param startRow starting row for the new page
 * @param pageSize number of records to request; defaults to {@link DEFAULT_PAGE_SIZE}
 */
export const preparePaginationQuery = (
  startRow: number,
  pageSize: number = DEFAULT_PAGE_SIZE,
): PaginationArgs => {
  const startIndex = startRow - 1;
  return {
    after: btoa(String(startIndex)), // Encoded value
    first: pageSize,
    paginationType: PaymentsPaginationType.Offset,
  };
};
